import { PageContainer } from '@/components/page-container.tsx';
import { Skeleton } from '@/components/ui/skeleton';

const CARD_HEIGHTS = ['h-44', 'h-64', 'h-36', 'h-52', 'h-40', 'h-60', 'h-32', 'h-56', 'h-48'];

/**
 * Router-wide default pending UI (`defaultPendingComponent`): shown in a route's
 * Outlet while its loader/`beforeLoad` resolves and the wait exceeds
 * `defaultPendingMs`, so navigating into a route with a blocking loader paints a
 * loading shell immediately (any already-resolved parent layout — e.g. the
 * `_logged` sidebar/header — stays mounted) instead of freezing on the previous
 * page. A cached navigation resolves under the threshold and never shows this.
 *
 * Deliberately generic — a title bar plus a staggered masonry grid of card blocks
 * (varying heights via CSS columns, with a cascading pulse). It reads as "this
 * page is loading" without mirroring any specific page, so it serves every route
 * and needs no per-page upkeep.
 */
export function PageLoadingSkeleton() {
  return (
    <PageContainer>
      <div className='space-y-2'>
        <Skeleton className='h-8 w-64' />
        <Skeleton className='h-4 w-44' style={{ animationDelay: '120ms' }} />
      </div>
      <div className='columns-1 gap-6 md:columns-2 xl:columns-3'>
        {CARD_HEIGHTS.map((height, index) => (
          <Skeleton
            key={height}
            className={`${height} mb-6 w-full break-inside-avoid rounded-xl`}
            style={{ animationDelay: `${index * 90}ms` }}
          />
        ))}
      </div>
    </PageContainer>
  );
}
